import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { jsx as _jsx } from "react/jsx-runtime";

var SvgListNumber = function SvgListNumber(props) {
  return _jsx("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    role: "img"
  }, props), {}, {
    children: _jsx("g", {
      fill: props.color || '#909090',
      children: _jsx("path", {
        d: "M1.646 5.078H.494V6h3.415v-.922h-.987V0H1.868L0 1.568l.44.576.054.04a.391.391 0 0 0 .14.053c.052.01.107.01.166 0a.401.401 0 0 0 .18-.085l.678-.564a9.17 9.17 0 0 0-.012.466v3.024ZM7 3a1 1 0 0 1 1-1h7a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1ZM7 8a1 1 0 0 1 1-1h7a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1ZM8 12a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2H8ZM2.243 10c.302 0 .573.043.814.128.242.086.447.205.618.357.17.152.3.333.391.543.09.211.136.442.136.695 0 .217-.031.418-.094.603-.063.184-.149.36-.258.527a3.702 3.702 0 0 1-.378.485l-.459.475-1.192 1.189a4.46 4.46 0 0 1 .454-.104c.149-.026.29-.038.42-.038h1.139c.14 0 .25.037.33.112a.382.382 0 0 1 .122.295V16H0v-.407c0-.08.017-.163.05-.253a.61.61 0 0 1 .176-.244l1.758-1.723c.15-.147.282-.287.393-.42a2.6 2.6 0 0 0 .276-.393c.073-.129.127-.258.164-.387.036-.129.054-.265.054-.41 0-.236-.058-.417-.174-.543-.115-.126-.292-.19-.529-.19a.791.791 0 0 0-.698.38l-.064.138c-.058.15-.135.248-.23.297-.095.05-.23.06-.406.033l-.686-.118c.044-.296.13-.554.257-.774a1.873 1.873 0 0 1 1.12-.878c.242-.072.503-.108.782-.108Z"
      })
    })
  }));
};

export default SvgListNumber;